import React from 'react';
import { Mail, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const year = new Intl.NumberFormat(i18n.language).format(new Date().getFullYear());

  return (
    <footer className="z-10 relative bg-[#1F1F1F] w-full pt-16 pb-8 text-[#D9D9D9]">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="font-poppins text-lg font-medium mb-4 hover:text-[#C8102E] transition-colors duration-300">
              {t('footer.brand')}
            </h3>
            <p className="text-sm text-[#AAAAAA] hover:text-[#C8102E] transition-colors duration-300">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h3 className="font-poppins text-lg font-medium mb-4 hover:text-[#C8102E] transition-colors duration-300">
              {t('footer.contact')}
            </h3>
            <p className="text-sm mb-2 text-[#AAAAAA] hover:text-[#C8102E] transition-colors duration-300">
              {t('footer.address')}
            </p>
            <p className="text-sm text-[#AAAAAA] hover:text-[#C8102E] transition-colors duration-300">
              mad73.arquitectos@gmail.com
            </p>
          </div>

          <div>
            <h3 className="font-poppins text-lg font-medium mb-4 hover:text-[#C8102E] transition-colors duration-300">
              {t('footer.connect')}
            </h3>
            <div className="flex flex-wrap items-center gap-4">
              <Link
                to="/contact"
                className="text-[#AAAAAA] hover:text-[#C8102E] transition-colors duration-300 cursor-pointer"
                aria-label={t('nav.contact')}
              >
                <Mail size={20} />
              </Link>
              <a
                href="https://www.instagram.com/mad73.arc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#AAAAAA] hover:text-[#C8102E] transition-colors duration-300 cursor-pointer"
                aria-label={t('contact.instagramTitle')}
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#3A3A3A] pt-8">
          <p className="text-xs text-center text-[#777] hover:text-[#C8102E] transition-colors duration-300">
            {t('footer.rights', { year })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
